export const initCookieHubBar = () => {
  const $container = $('.ch2-dialog');

  if ($container.length) {
    $container.addClass('init');
  }
}
